import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "openButton"]

  declare menuTarget: HTMLElement
  declare hasMenuTarget: boolean
  declare openButtonTarget: HTMLElement
  declare hasOpenButtonTarget: boolean

  open() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("is-open")
      this.element.classList.add("is-menu-open")
      if (this.hasOpenButtonTarget) {
        this.openButtonTarget.setAttribute("aria-expanded", "true")
      }
    }
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove("is-open")
      this.element.classList.remove("is-menu-open")
      if (this.hasOpenButtonTarget) {
        this.openButtonTarget.setAttribute("aria-expanded", "false")
      }
    }
  }
}
